/**
 * Takes an array of list nodes and merges them into a single list node.
 *
 * @param {Array} listNodes The list of list nodes to merge
 *
 * @returns {Object} A list node containing the merged content of the lists
 */
export const mergeLists = (listNodes) => {

	let listItems = [];

	const listGroupType = listNodes[0] && listNodes[0].type;

	listNodes.forEach((listNode) => {

		listItems = listItems.concat(listNode.content.content);

	});

	return listGroupType && listGroupType.create({}, listItems);

};
